export default __webpack_public_path__ + "static/Avenir-Medium-09-d8d1e696938fc85d488a32e4c03c385c.ttf";